
import { GxTabPanel, GxTextarea } from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import { FormikProps } from 'formik';
import React, { FC } from 'react';
import DatePicker from 'react-multi-date-picker';
import 'react-responsive-modal/styles.css';
import CalendarInput from '../../../../../components/CalendarInput';
import InputNumbers from '../../../../../components/InputNumbers';
import Select from '../../../../../components/Select';
import { MODAL_USER_PANELS } from '../../../../../const';
import { months, weekDays } from '../../../../../const/calendar';
import styles from '../styles/index.module.scss';
import { IInitialValues } from '../types';

interface IAdressPanel {
    formik: FormikProps<IInitialValues>
}

const DocumentsPanel: FC<IAdressPanel> = ({ formik }) => {
    const { values, handleChange, setFieldValue } = formik

    const options = {
        passport: [
            { value: 0, label: 'Паспорт' },
        ]
    }

    return (
        <GxTabPanel name={MODAL_USER_PANELS.documents}>
            <div className={styles['user']}>
                <div className={styles['user--container']}>
                    <div className={styles['user--partner']}>
                        <span className={styles['partner--label']}>Вид документа</span>
                        <div className={styles['document--select']}>
                            <Select
                                name='documents.document_type'
                                defaultValue={options.passport[0]}
                                options={options.passport}
                                onChange={(option: any): any => setFieldValue('documents.document_type', option.value)}
                            />
                        </div>
                    </div>
                    <div className={styles['document--group']}>
                        <InputNumbers
                            name="documents.document_number"
                            handleChange={handleChange}
                            label='Номер:'
                            className={cn(styles['item'], styles['item--documents_input'])}
                            value={values.documents.document_number}
                        />
                        <InputNumbers
                            name="documents.document_serial"
                            handleChange={handleChange}
                            label='Серия:'
                            className={
                                cn(
                                    styles['item--documents_input'],
                                    styles['item--documents_input_sec'],
                                )}
                            value={values.documents.document_serial}
                        />
                    </div>
                    <div className={styles['document--group']}>
                        <div className={styles['issued-by']}>
                            <span className={styles['issued-by--label']}>Дата выдачи:</span>
                            <DatePicker
                                weekDays={weekDays}
                                format="DD.MM.YYYY"
                                months={months}
                                render={<CalendarInput type='sm_s' />}
                                onChange={(date: any) => setFieldValue('documents.document_granted', date.format('DD.MM.YYYY'))}
                                value={values.documents.document_granted}
                                weekStartDayIndex={1}
                                className={styles['item--documents_input']}
                            />
                        </div>
                        <InputNumbers
                            name="documents.document_department_code"
                            handleChange={handleChange}
                            label='Код:'
                            className={cn(
                                styles['item--documents_input_sec'],
                                styles['item--documents_input']
                            )}
                            value={values.documents.document_department_code}
                        />
                    </div>
                    <GxTextarea
                        name="documents.document_granted_by"
                        onGx-change={handleChange}
                        label='Кем выдан:'
                        className={cn(styles['item'], styles['text-area'])}
                        resize='none'
                        value={values.documents.document_granted_by}
                    />
                </div>
            </div>
        </GxTabPanel>
    )
}

export default DocumentsPanel


